import TabController from "./tab-controller";
import * as ko from "knockout";
class TabPagePreview implements Factories.TabPage {
    Parent: any;
    constructor(search: any) {
        this.Parent = search;
        this.Context.subscribe((newValue) => {
            if (newValue != null && newValue.Container != null && newValue.Container() != null && newValue.Container().length > 0) {
                this.ToolbarButtons(newValue.Container()[0].Buttons());
            }
        });
    }
    Menu = {
        registerEvent: (fn: Function) => {
            this.MenuEvent = fn;
        },
        permissionEnable: (p: {
            ActionKey: string;
            Enabled: boolean;
        }) => {
            this.EnableButton(p.ActionKey, p.Enabled);
        }
    };
    destroy = () => {
        this.Parent.Selection([]);
        this.Parent.PerformSearch(); //destroy is called only if item were deleted, so refresh the search!
    };
    EnableButton = (actionKey: string, enable: boolean) => {
        //Dummy
    };
    MenuEvent: Function = null;
    TemplateName = ko.observable<string>("");
    ToolbarButtons = ko.observableArray<any>([]);
    ToolbarClick = (button) => {
        if (this.MenuEvent != null) {
            this.MenuEvent(button);
        }
    };
    //_viewModelFactory = (_creator: Function | Object, params: any[]) => {
    //    var viewModelInstance = null;
    //    if (typeof _creator == "function") {
    //        params.push(this.Menu);
    //        viewModelInstance = ko["construct"](_creator, params);
    //    }
    //    else {
    //        viewModelInstance = _creator;
    //    }
    //    return viewModelInstance;
    //}
    subscriptions: KnockoutSubscription[];
    AutoSelect: boolean = false;
    MenuEvents = [];
    DirtyFlag = ko["dirtyFlag"]();
    Route: any = {};
    $TabController: TabController;
    TabAdded: KnockoutObservable<boolean>;
    ViewModel: KnockoutObservable<any> = ko.observable<any>();
    Context: KnockoutObservable<any> = ko.observable();
    IsLoading: KnockoutObservable<boolean> = ko.observable(false);
    ObjectId: KnockoutObservable<any> = ko.observable();
    UrlData: KnockoutObservable<any> = ko.observable();
    Title: KnockoutObservable<string> = ko.observable("");
    IsActiveTab: KnockoutObservable<boolean> = ko.observable(true);
    TabViewModel: KnockoutObservable<any>;
    StatusBarVisible: KnockoutObservable<boolean>;
    Id: KnockoutObservable<string>;
    Version: KnockoutObservable<string>;
    EnableDirtyTracking: KnockoutObservable<boolean>;
    IsDirty: KnockoutObservable<boolean>;
    ToolTip: KnockoutObservable<string>;
    IsClosable: KnockoutObservable<boolean>;
    Url: KnockoutObservable<string>;
    JavaScript: KnockoutObservable<any>;
    Visible: KnockoutObservable<boolean>;
    Loaded: KnockoutObservable<boolean>;
    PreLoad: KnockoutObservable<boolean>;
    Icon: KnockoutObservable<string>;
    LoadingAllowed: KnockoutObservable<boolean>;
    ScrollPosition: KnockoutObservable<any>;
    LoadContent: KnockoutComputed<void>;
    StatusIconComputed: KnockoutComputed<boolean>;
    TitleComputed: KnockoutComputed<string>;
    ClearMenuEvents: () => JQueryPromise<void>;
    OpenStatusDialog: () => JQueryPromise<void>;
    TabLoaded: () => void;
    TabSelected: () => void;
    TabUnselected: () => void;
    SessionTabId: string;
}
export default TabPagePreview;